import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SlidersHorizontal } from 'lucide-react';
import GenericSelect from '../../components/ui/GenericSelect';
import { PageWrap, FloatingFilters, FilterIcon, Grid } from './styles';
import { useAtsDashboardApi, RANGE_PRESETS } from './config/useAtsDashboardApi';
import KpiStripCard from './components/KpiStripCard';
import FunnelCard from './components/FunnelCard';
import StageDurationCard from './components/StageDurationCard';
import SlaBreachCard from './components/SlaBreachCard';
import SourceConversionCard from './components/SourceConversionCard';
import AgingPoolCard from './components/AgingPoolCard';
import InterviewHealthCard from './components/InterviewHealthCard';

// ATS Pano — brief'in kopyalanacak kalıbı: leave-dashboard/expense-dashboard
// ile AYNI iskelet (PageWrap → FloatingFilters → Grid). Backend HENÜZ YOK;
// GET /v1/ats-dashboard sözleşmesi dondurulmuş (bkz. services/atsDashboardService.js).
// İkinci bir başlık şeridi YOK (UI ALTIN KURALI) — dönem seçici leave-dashboard
// gibi sağ-alt köşede yüzen tek bir GenericSelect.
export default function AtsDashboardPage() {
  const { t } = useTranslation();
  const { range, setRange, data, loading } = useAtsDashboardApi();

  const rangeOptions = useMemo(() => RANGE_PRESETS.map((value) => ({
    id: value,
    name: t(`atsDashboard.filters.range.${value}`),
  })), [t]);

  return (
    <PageWrap>
      <FloatingFilters data-export-exclude>
        <FilterIcon><SlidersHorizontal size={14} /></FilterIcon>
        <GenericSelect
          options={rangeOptions}
          value={range}
          onChange={(value) => setRange(value || 'last90')}
          clearable={false}
          size="small"
          direction="top"
        />
      </FloatingFilters>
      <Grid>
        <KpiStripCard data={data?.kpi} loading={loading} />
        <FunnelCard data={data?.funnel} loading={loading} />
        <StageDurationCard data={data?.stageDurations} loading={loading} />
        <SlaBreachCard data={data?.slaBreach} loading={loading} />
        <SourceConversionCard data={data?.sources} loading={loading} />
        <AgingPoolCard data={data?.aging} loading={loading} />
        <InterviewHealthCard data={data?.interviewHealth} loading={loading} />
      </Grid>
    </PageWrap>
  );
}
